import { useQuery } from "@tanstack/react-query";

export function useFactura(Id) {
   const urlFact = process.env.REACT_APP_URL_DIR + "presupuesto/" + Id;
   const token = localStorage.getItem("token");

   return useQuery({
      queryKey: ["Factura", Id], // include Id so it re-fetches when Id changes
      queryFn: async () => {
         const res = await fetch(urlFact, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         });

         if (!res.ok) {
            throw new Error(`Error ${res.status}: ${res.statusText}`);
         }

         return res.json();
      },
      enabled: !!Id, // avoids fetching when Id is null/undefined
   });
}
